export enum AddressType {
  postal = 'POSTAL',
  physical = 'PHYSICAL',
  postalPhysical = 'BOTH',
}
